import { get, post, put, del } from './client'

export interface Redemption {
  id: number
  name: string
  key: string
  quota: number
  status: number
  used_user_id?: number
  redeemed_time?: number
  created_time: number
  count?: number
}

export interface RedemptionListParams {
  p?: number
  size?: number
}

export interface RedemptionListResponse {
  items: Redemption[]
  total: number
  page: number
  page_size: number
}

export interface CreateRedemptionParams {
  name: string
  quota: number
  count: number
}

/**
 * 兑换码列表
 * GET /api/redemption/
 */
export async function getRedemptionsApi(
  params?: RedemptionListParams
): Promise<RedemptionListResponse> {
  return get<RedemptionListResponse>('/api/redemption/', params)
}

/**
 * 创建兑换码
 * POST /api/redemption/
 */
export async function createRedemptionApi(
  data: CreateRedemptionParams
): Promise<Redemption[]> {
  return post<Redemption[]>('/api/redemption/', data)
}

/**
 * 更新兑换码
 * PUT /api/redemption/
 */
export async function updateRedemptionApi(data: Partial<Redemption>): Promise<void> {
  return put('/api/redemption/', data)
}

/**
 * 删除兑换码
 * DELETE /api/redemption/:id/
 */
export async function deleteRedemptionApi(id: number): Promise<void> {
  return del(`/api/redemption/${id}/`)
}

/**
 * 搜索兑换码
 * GET /api/redemption/search
 */
export async function searchRedemptionsApi(keyword: string): Promise<Redemption[]> {
  return get<Redemption[]>('/api/redemption/search', { keyword })
}
